import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
    selector: 'app-template-management',
    templateUrl: './template-management.component.html',
    styleUrls: ['./template-management.component.scss']
})
export class TemplateManagementComponent implements OnInit
{
    @HostBinding('class') classes = 'bg mat-typography';
    constructor() { }

    ngOnInit(): void
    {
    }

}
